import baseURLv1 from '@/services/APIConfig.js';
import { add, append, remove, set, update } from '@/vuex/helpers';

export default {
  namespaced: true,
  state: {
    isLoading: false,
    companies: [],
    allCompanies: [],
    companiesByNameOrIco: null,
    filters: {
      is_active: null,
      order_by: 'short_name',
      search: '',
      page: 1,
      page_size: 10,
    },
    companiesByNameOrIcoFilters: {
      order_by: 'fullname',
    },
    previous: null,
    next: null,
  },
  mutations: {
    set,
    update,
    add,
    remove,
    append,
    updateFilter(state, { field, payload }) {
      state.filters[field] = payload;
      if (field !== 'page') {
        state.filters.page = 1;
      }
    },
    sortCompaniesByNameOrIco(state, { field, payload }) {
      const isDescending = payload.startsWith('-');
      const sortField = isDescending ? payload.slice(1) : payload;

      state.companiesByNameOrIcoFilters[field] = payload;

      state.companiesByNameOrIco.sort((a, b) => {
        if (a[sortField] > b[sortField]) return isDescending ? -1 : 1;
        if (a[sortField] < b[sortField]) return isDescending ? 1 : -1;
        return 0;
      });
    },
  },
  actions: {
    async addClientsCompany({ commit }, { payload }) {
      const company = await this.$axios.post(`${baseURLv1}/client_company/`, payload);
      commit('add', ['companies', company.data.data]);
    },

    async searchCompanyByNameOrIco({ commit }, { payload: { name, ico } }) {
      const params = {
        page_size: 200,
      };

      if (ico != null && ico !== '') {
        params.ico_number = ico;
      } else {
        params.company_name = name;
      }

      const response = await this.$axios.get(`${baseURLv1}/client_company/ares/`, { params });

      commit('set', ['companiesByNameOrIco', response.data.data]);
    },

    resetCompaniesByNameOrIco({ commit }) {
      commit('set', ['companiesByNameOrIco', null]);
      commit('set', ['companiesByNameOrIcoFilters', {
        order_by: 'fullname',
      }]);
    },

    async editCompany({ commit }, { company, id }) {
      const response = await this.$axios.patch(`${baseURLv1}/client_company/${id}/`, company);

      commit('update', ['companies', { id, payload: response.data.data }]);
    },

    async getCompanyDetails({ commit }, { id }) {
      const response = await this.$axios.get(`${baseURLv1}/client_company/${id}/`);

      return response.data.data;
    },

    async deleteCompany({ commit }, id ) {
      const response = await this.$axios.delete(`${baseURLv1}/client_company/${id}/`);

      commit('remove', ['companies', id]);
      return response.data.data;
    },

    async load({ state, commit }, payload) {
      commit('set', ['isLoading', true]);
      const passedParams = payload ?? {}; // page, page_size
      const response = await this.$axios.get(`${baseURLv1}/client_company/`, {
        params: {
          ...state.filters,
          ...passedParams,
        },
      });

      commit('set', ['companies', response.data.data]);
      commit('set', ['previous', response.data.previous]);
      commit('set', ['next', response.data.next]);
      commit('set', ['isLoading', false]);
    },
    async loadAllCompanies({ commit }) {
      const response = await this.$axios.get(`${baseURLv1}/client_company/`, {
        params: {
          page: 1,
          page_size: 1000,
        },
      });

      commit('set', ['allCompanies', response.data.data]);
    },
  },
  getters: {
    selectOptions: (state) =>
      state.allCompanies
        .filter((el) => el.is_active)
        .map((u) => ({ name: u.short_name, id: u.id }))
        .sort((a, b) => a.name.localeCompare(b.name)),
    selectOptionsAreEmpty: (state) => state.allCompanies.length === 0,
  },
};
